import "./index.css";
import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import PostDetail from "./PostDetail";
import AddPost from "./components/AddPost";
import EditPost from "./components/EditPost";
import ReactPlayer from "react-player";
import delete_icon from "../../assets/media/feeds/delete.png";
import { getYoutubeId } from "../../Utils/utils";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
  EMOJI_LEAVE,
} from "../../Constants/types";
import { EmojiStyle, Emoji } from "emoji-picker-react";
import ConfirmationModal from "../../components/ConfirmationModal";

class Feeds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      loading: true,
      loading_script: "",
      posts: [],
      users: [],
      uploadTask: null,
      postData: null,
      umbrellaBrand: false,
      toEditPostData: null,
    };
    this.editPostBtnRef = React.createRef();
    this.deletePostBtnRef = React.createRef();
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      const { myRole } = this.props;
      this.setState({ username, role, brand });
      Firebase.getBrandDataByID(brand, (brand_data) => {
        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          umbrellaBrand: brand_data.umbrella,
          hex: brand_data.hex,
          white: brand_data.white,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
        });
        const { parent } = brand_data;
        Firebase.getAllPosts(brand_data.name, (posts) => {
          if (parent) {
            // I am inside sub brand and wanna get parent articles
            Firebase.getBrandDataByID(parent, (parentBrand_Data) => {
              const parentBrandName = parentBrand_Data.name;
              Firebase.getAllPosts(parentBrandName, (res) => {
                const parentPosts = res.filter((a) => a.postToSub);
                this.setState({
                  posts: [...posts, ...parentPosts],
                  loading: false,
                });
              });
            });
          } else {
            posts.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
            if (myRole === "isUmbrella" && brand_data.umbrella) {
              this.setState({
                posts: posts.filter((item) => item.postToSub),
                loading: false,
              });
            } else this.setState({ posts, loading: false });
          }
        });
        Firebase.getAllUsers(brand_data.name, this.subscribeUsers);
      });
    }
  }

  subscribeUsers = (users) => {
    this.setState({ users });
  };

  onAccept = (post) => () => {
    const { brand_name } = this.state;
    Firebase.updatePost(brand_name, post.id, { accepted: true, postNow: true });
  };

  handlePost = async (postData) => {
    const uid = localStorage.getItem("uid");
    const { postNow, scheduledDate } = postData;
    const { brand_name, username, umbrellaBrand } = this.state;
    const { myRole } = this.props;
    let post = {
      ...postData,
      uid,
      username,
      scheduledDate: scheduledDate.valueOf(),
    };
    if (myRole === "isUmbrella" && umbrellaBrand) post.postToSub = true;
    let res = await Firebase.addPost(post, brand_name);
    if (!postNow) {
      let schedule_data = {
        id: res.id,
        type: "feed",
        time: scheduledDate.valueOf(),
        brand_name: brand_name,
      };
      await Firebase.registerSchedule(schedule_data);
    }
  };
  handleEdit = (payload) => {
    const { brand_name, toEditPostData } = this.state;
    Firebase.updatePost(brand_name, toEditPostData.id, payload);
  };
  onDecline = (post) => () => {
    const { brand_name } = this.state;
    Firebase.updatePost(brand_name, post.id, { accepted: false });
  };

  deletePost = (post) => {
    const { brand_name } = this.state;
    Firebase.deletePost(brand_name, post.id);
    Firebase.removeSchedule(post.id);
  };

  onPostNow = (post) => () => {
    const { brand_name } = this.state;
    Firebase.updatePost(brand_name, post.id, {
      postNow: true,
      timestamp: new Date(),
      scheduledDate: moment().valueOf(),
    });
  };
  onClickEdit = (post) => () => {
    this.setState({ toEditPostData: post });
    this.editPostBtnRef.current.click();
  };
  renderPosts = () => {
    const { posts, brand_name, hex, white } = this.state;
    return (
      <div>
        <button
          className="btn-add btn-brand-hex"
          style={{
            backgroundColor: "white",
            color: "black",
            "--hover-text-color": white ? "white" : "black",
            "--hover-color": hex || "white",
          }}
          data-toggle="modal"
          data-target="#add_feed_modal"
        >
          <p style={{ fontSize: "65px", lineHeight: "65px" }}>+</p>
          <p className="event-item-text">Add Feeds Post</p>
        </button>
        <button
          style={{ display: "none" }}
          data-toggle="modal"
          data-target="#edit_feed_modal"
          ref={this.editPostBtnRef}
        />
        <button
          style={{ display: "none" }}
          ref={this.deletePostBtnRef}
          data-toggle="modal"
          data-target="#delete_post"
        />
        {posts.map((post, index) => (
          <div className="post-container" key={index}>
            {(post.media_type === IMAGE_UPLOAD ||
              post.media_type === GIF_UPLOAD) && (
              <div
                className="img-container"
                style={{ backgroundImage: `url("${post.media_url}")` }}
              >
                <img
                  src={delete_icon}
                  width="30"
                  onClick={() => this.deletePostBtnRef.current.click()}
                  alt="delete-icon"
                />
              </div>
            )}
            <ConfirmationModal
              id="delete_post"
              type="post"
              onClick={() => this.deletePost(post)}
              hex={hex}
              white={white}
            />
            {post.media_type === VIDEO_UPLOAD && (
              <div className="player-container">
                <ReactPlayer
                  url={post.media_url}
                  width="100%"
                  height="100%"
                  controls={true}
                />
                <img
                  className="deleteIcon"
                  src={delete_icon}
                  width="30"
                  onClick={() => this.deletePost(post)}
                  alt="delete-icon"
                />
              </div>
            )}
            {post.media_type === YOUTUBE_URL && (
              <div style={{ position: "relative" }}>
                <iframe
                  title="video"
                  width="300"
                  height="150"
                  src={`//www.youtube.com/embed/${getYoutubeId(
                    post.media_url
                  )}?modestbranding=1&showinfo=0`}
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
                <img
                  className="deleteIcon"
                  src={delete_icon}
                  width="30"
                  onClick={() => this.deletePost(post)}
                  alt="delete-icon"
                />
              </div>
            )}
            {post.media_type === EMOJI_LEAVE && (
              <div className="emoji-display">
                <Emoji
                  unified={post.media_url}
                  emojiStyle={EmojiStyle.APPLE}
                  size={75}
                />
                <img
                  className="deleteIcon"
                  src={delete_icon}
                  width="30"
                  onClick={() => this.deletePost(post)}
                  alt="delete-icon"
                />
              </div>
            )}
            <PostDetail
              post={post}
              users={this.state.users}
              brand_name={brand_name}
              onAccept={this.onAccept}
              onDecline={this.onDecline}
              onPostNow={this.onPostNow}
              onEdit={this.onClickEdit(post)}
              white={white}
              hex={hex}
            />
          </div>
        ))}
      </div>
    );
  };

  render() {
    const {
      username,
      role,
      logo,
      brand,
      is_property_brand,
      loading,
      loading_script,
      brand_name,
      toEditPostData,
      hex,
      white,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container" className="feeds-content">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
              <p>{loading_script}</p>
            </div>
          )}
          {!loading && this.renderPosts()}
          <AddPost
            onAdd={this.handlePost}
            brand_name={brand_name}
            hex={hex}
            white={white}
          />
          <EditPost
            onEdit={this.handleEdit}
            brand_name={brand_name}
            postData={toEditPostData}
            hex={hex}
            white={white}
            deletePostBtnRef={this.deletePostBtnRef}
          />
        </main>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    myRole: state.myRole,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Feeds);



// WEBPACK FOOTER //
// ./src/screens/Feeds/index.js